import { render, staticRenderFns } from "./CVSImporter.vue?vue&type=template&id=0bafee9d"
import script from "./CVSImporter.vue?vue&type=script&lang=js"
export * from "./CVSImporter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports